import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'percentage'
})
export class PercentagePipe implements PipeTransform {

  transform(value: number): string {    
    if (isNaN(value) || value == null) {
      return ''; // Retorna vazio se o valor não for um número
    }
    return `${value.toFixed(2)}%`; // Formata o número com 2 casas decimais e adiciona o símbolo de porcentagem
  }
}
